import EmojiObjectsRoundedIcon from "@mui/icons-material/EmojiObjectsRounded";
import { Box, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { getDeepViewLineageEntry } from "../deepViewFieldMap";
import { renderDeepViewText } from "../renderDeepViewText";

interface Props {
  columnKey?: string;
}

const PlainEnglishCardData = ({ columnKey }: Props) => {
  const deepViewData = useSelector(
    (state: any) => state?.deepView?.deepViewData,
  );
  const lineageEntry = getDeepViewLineageEntry(deepViewData, columnKey);

  if (!lineageEntry?.full_summary) return null;

  return (
    <>
      <Box
        sx={{
          border: "1px solid #0288D180",
          borderRadius: "8px",
          backgroundColor: "#0288D10A",
          p: 1,
          mb: 1,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <EmojiObjectsRoundedIcon
            sx={{
              color: "#01579B",
              fontSize: 18,
            }}
          />

          <Typography
            sx={{
              color: "#01579B",
              fontSize: "14px",
              fontWeight: 500,
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            How We Calculate {lineageEntry.field_label}
          </Typography>
        </Stack>

        <Typography
          sx={{
            color: "#01579B",
            fontSize: "14px",
            lineHeight: "20px",
          }}
        >
          {renderDeepViewText(lineageEntry.full_summary)}
        </Typography>
      </Box>
    </>
  );
};

export default PlainEnglishCardData;
